module.exports = __webpack_public_path__ + "static/img/ruggedian-text-4.69b653d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ruggedian-text-4.png
// module id = 126
// module chunks = 0